module.exports = __webpack_public_path__ + "static/media/reform_health_vert_500.4e374c44.png";